import { createReducer, on } from '@ngrx/store';
import { initialState } from '../../models/stat/simple-mode.state';
import * as SimpleModeActions from '../actions/simple-mode.actions';

export const simpleModeReducer = createReducer(
  initialState,
  on(SimpleModeActions.toggleSimpleMode, (state) => ({
    ...state,
    simpleMode: !state.simpleMode,
  })),
  on(SimpleModeActions.setSimpleMode, (state, { simpleMode }) => ({
    ...state,
    simpleMode,
  }))
);